module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showToTop) ? _c('div', {
    staticClass: "totop",
    on: {
      "click": function($event) {
        _vm.gotoTop()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('../../static/img/totop.png')
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.noProduct) ? _c('div', {
    staticClass: "noproduct"
  }, [_c('img', {
    attrs: {
      "src": require('../../static/img/noproduct.png')
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isReload) ? _c('div', [(_vm.type == _vm.headType.wxShare) ? _c('div', _vm._l((_vm.taokes), function(taoke, index) {
    return _c('v-tao', {
      key: taoke.GoodsID,
      attrs: {
        "item": taoke,
        "types": _vm.types,
        "idx": index
      }
    })
  })) : _c('div', _vm._l((_vm.taokes), function(taoke, index) {
    return _c('v-double', {
      key: taoke.GoodsID,
      attrs: {
        "item": taoke,
        "type": _vm.type,
        "types": _vm.types,
        "idx": index
      }
    })
  }))]) : _c('div', {
    style: (_vm.bodyStyle)
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(!(_vm.type == _vm.headType.wxShare)) ? _c('img', {
    staticStyle: {
      "margin-top": "30%",
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "src": require('../../static/img/loading.gif')
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px",
      "color": "#4c4c4c"
    }
  }, [_vm._v("\n      努力加载中...\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "loading"
  }, [(_vm.isUpPage) ? _c('div', {
    class: _vm.loadCss
  }, [_vm._v("\n      正在加载。。。\n    ")]) : _c('div', [(!_vm.isEnd) ? _c('span', {
    staticStyle: {
      "color": "#4c4c4c"
    }
  }, [_vm._v("下拉显示更多")]) : _c('span', {
    staticStyle: {
      "color": "#4c4c4c"
    }
  }, [_vm._v("没有更多产品")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd01b94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Body.vue
// module id = 199
// module chunks = 2